// Mock data for Torque Autohaus

export const mockServices = [
  {
    id: 1,
    title: 'ECU Remapping',
    description: 'Unlock hidden power and optimize fuel efficiency with custom ECU calibration tailored to your vehicle.',
    icon: 'Cpu',
    link: '#contact'
  },
  {
    id: 2,
    title: 'Performance Upgrades',
    description: 'Premium aftermarket parts and professional installation for exhaust systems, intakes, and turbo upgrades.',
    icon: 'Zap',
    link: '#contact'
  },
  {
    id: 3,
    title: 'Diagnostics',
    description: 'Advanced diagnostic tools to identify and resolve performance issues, fault codes, and system problems.',
    icon: 'Activity',
    link: '#contact'
  },
  {
    id: 4,
    title: 'Performance Suspension',
    description: 'Professional suspension upgrades, coilover installations, and alignment services for enhanced handling and comfort.',
    icon: 'Settings',
    link: '#contact'
  },
  {
    id: 5,
    title: 'Custom Interior Lighting',
    description: 'Premium ambient lighting systems and starlight headliner installations to transform your vehicle interior.',
    icon: 'Lightbulb',
    link: '#contact'
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: 'Gurman',
    vehicle: 'Mercedes-AMG C63 S',
    rating: 5,
    comment: 'Stage 2 on my C63 S is an absolute weapon. The power delivery is relentless and the gains are exactly what they promised. Couldn\'t be happier with the result.',
    date: '2024-12-15'
  },
  {
    id: 2,
    name: 'Hammad',
    vehicle: '2020 Audi RS3',
    rating: 5,
    comment: 'Best decision I made for my RS3. The custom tune is perfect - aggressive when I want it, smooth for daily driving. These guys know their craft.',
    date: '2024-11-28'
  },
  {
    id: 3,
    name: 'Mark',
    vehicle: 'Audi S6',
    rating: 5,
    comment: 'Had the turbos upgraded on my S6 and the difference is insane. Way more top-end pull and it holds boost all the way through. These guys absolutely nailed the build.',
    date: '2024-11-10'
  }
];

export const mockGalleryItems = [
  {
    id: 1,
    title: 'Audi RS6 Custom Build',
    description: 'Performance tuned',
    image: 'https://customer-assets.emergentagent.com/job_car-tune-experts/artifacts/oi9pj01m_IMG_0061.jpg'
  },
  {
    id: 2,
    title: 'Mercedes-AMG E63',
    description: 'Performance package',
    image: 'https://customer-assets.emergentagent.com/job_car-tune-experts/artifacts/5hkzaktk_IMG_7070.jpeg'
  },
  {
    id: 3,
    title: 'Mercedes-AMG E63',
    description: 'V8 BiTurbo performance',
    image: 'https://customer-assets.emergentagent.com/job_car-tune-experts/artifacts/0wvui6or_IMG_6784.JPG'
  },
  {
    id: 4,
    title: 'Audi RS6 Turbo Setup',
    description: 'Twin turbo upgrade',
    image: 'https://customer-assets.emergentagent.com/job_car-tune-experts/artifacts/7vfwnk4l_59FFED06-30BC-4A8B-B7A4-9978AB40D694.jpeg'
  },
  {
    id: 5,
    title: 'AMG Wagon & E63 Duo',
    description: 'Twin AMG builds',
    image: 'https://customer-assets.emergentagent.com/job_9a561175-5bf3-4a7e-a383-8fff68bc2d5c/artifacts/kaxpng87_2F2A86E9-F6A2-49C2-955C-737688BDC566%20%281%29.jpeg'
  },
  {
    id: 6,
    title: 'Audi RS6 Avant',
    description: 'Stage tuned wagon',
    image: 'https://customer-assets.emergentagent.com/job_9a561175-5bf3-4a7e-a383-8fff68bc2d5c/artifacts/431drgem_IMG_8920.jpeg'
  }
];